import React, { useState, useEffect, Fragment, useCallback } from 'react';
import localization from 'assets/localization/localization';
import { STATUS } from 'constants/statusConstant';
import DivLayout from 'components/sales/divLayout/divLayout';
import ReactStars from 'react-rating-stars-component';
import moment from 'moment';
import './leadDetails.css'
import DocumentView from "../../downloadDocView/documentView";
const LeadDetail = ({ details, pageTitle, giveRating, getRating, leadType = 0 }) => {
  const [teamId, setTeamId] = useState();
  const [starRating, setStarRating] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchRating = useCallback(async () => {
    if (getRating && details?.site?.id) {
      let { rating } = await getRating({ site_id: details?.site?.id });
      rating && setStarRating(rating);
    }
  }, [getRating, details?.site?.id]);

  useEffect(() => {
    fetchRating();
  }, [fetchRating]);

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      let team =
        (await JSON.parse(localStorage.getItem('viewDetail'))) &&
        JSON.parse(localStorage.getItem('viewDetail'))[0]?.lead_type_id;

      if(team === undefined){
        team = (await JSON.parse(localStorage.getItem('viewDetail'))) &&
        JSON.parse(localStorage.getItem('viewDetail'))[0]?.lead_type?.id;
      }
      setTeamId(team);
    })();
    setIsLoading(false);
  }, []);

  const handleRating = (val) => {
    setStarRating(val);
    giveRating({ rating: val, site_id: details?.site?.id });
  };

  return (
    <Fragment>
      <h3 className="panel-heading plr-1">
        {localization.details}
        {getRating && (
          <div className="site-rating" style={{ float: 'right' }}>
            <ReactStars
              key={starRating}
              count={5}
              value={starRating}
              onChange={handleRating}
              size={34}
              // isHalf={true}
              emptyIcon={<i className="far fa-star"></i>}
              halfIcon={<i className="fa fa-star-half-alt"></i>}
              fullIcon={<i className="fa fa-star"></i>}
              activeColor="#ffd700"
              edit={true}
            />
          </div>
        )}
      </h3>
      {!!details?.lead_data && (
        <Fragment>
          {/* <div className="panel_align"> */}
            
          <div className="panel-card card-details" width="100%">
            <div className="panel-heading">{localization.leadDetails}</div>
            <div className="panel-body">
              <div className="details-listing detail_alignment">
                <DivLayout
                  heading={localization.leadNumber}
                  data={
                    details.lead_data?.id
                      ? details.lead_data.id
                      : localization.na
                  }
                />
                { details.lead_data && details.lead_data.site_no?
                  <DivLayout
                  heading={localization.siteNumber}
                  data={
                    details.lead_data?.site_no
                      ? details.lead_data.site_no
                      : localization.na
                  }
                />
                : null
                }
                
                {details.lead_data && details.lead_data.company_name ? (
                  <DivLayout
                    heading={localization.clientBusinessName}
                    data={
                      details.lead_data?.company_name
                        ? details.lead_data.company_name
                        : localization.na
                    }
                  />
                ) : (
                  <DivLayout
                    heading={localization.clientBusinessName}
                    data={
                      details.lead_data?.client_name
                        ? details.lead_data.client_name
                        : localization.na
                    }
                  />
                )}
                {details.lead_data && details.lead_data.lead_type != "Apartment" ? (
                <DivLayout
                    heading={localization.building_name}
                    data={
                      details.lead_data?.building_name
                        ? details.lead_data.building_name
                        : localization.na
                    }
                  />
                ) : ''
                }
                <DivLayout
                  heading={localization.createdOn}
                  data={
                    details.lead_data?.created_at
                      ? details.lead_data.created_at
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.siteType}
                  data={
                    details.lead_data?.location_type
                      ? details.lead_data.location_type
                      : localization.na
                  }
                />
                
                {(leadType === STATUS.SUPPLY || teamId === STATUS.SUPPLY) ? (
                  <DivLayout
                    heading={localization.siteType}
                    data={
                      details.lead_data?.site_type
                        ? details.lead_data.site_type
                        : localization.na
                    }
                  />
                ) : (
                  <Fragment>
                    <DivLayout
                      heading={localization.LeadSource}
                      data={
                        details.lead_data?.lead_source
                          ? details.lead_data.lead_source
                          : localization.naLeadSource
                      }
                    />
                    {details.lead_data?.alternateChannle && (
                      <DivLayout
                        heading={'Alternate Channel'}
                        data={
                          details.lead_data?.alternateChannle
                            ? details.lead_data.alternateChannle
                            : localization.naLeadSource
                        }
                      />
                    )}
                    {details.lead_data?.mainSource && (
                      <DivLayout
                        heading={localization.mainSource}
                        data={
                          details.lead_data?.mainSource
                            ? details.lead_data.mainSource
                            : localization.naLeadSource
                        }
                      />
                    )}
                    {details.lead_data?.other_lead_source && (
                      <DivLayout
                        heading={'Other ' + localization.LeadSource}
                        data={
                          details.lead_data?.other_lead_source
                            ? details.lead_data.other_lead_source
                            : localization.naLeadSource
                        }
                      />
                    )}
                  </Fragment>
                )}
                {details.lead_data?.occupancy && 
                <DivLayout
                  heading={localization.occupancy}
                  data={
                    details.lead_data?.occupancy
                      ? details.lead_data.occupancy
                      : localization.na
                  }
                />
                }
                {details.lead_data?.existing_solution && 
                <DivLayout
                  heading={localization.existingSolution}
                  data={
                    details.lead_data?.existing_solution
                      ? details.lead_data.existing_solution
                      : localization.na
                  }
                />
                }
                {details.lead_data?.is_marquee_site && 
                <DivLayout
                  heading={localization.marqueeSite}
                  data={
                    details.lead_data?.is_marquee_site
                      ? details.lead_data.is_marquee_site
                      : localization.na
                  }
                />
                } 
                <DivLayout
                  heading={localization.salesTeamMember}
                  data={
                    details.lead_data?.assigned_to
                      ? details.lead_data.assigned_to
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.salesMemberDesignation}
                  data={
                    details.lead_data?.assigned_to_designation
                      ? details.lead_data.assigned_to_designation
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.status}
                  status
                  data={
                    details.lead_data?.status
                      ? details.lead_data.status
                      : localization.na
                  }
                />
                {details.lead_data?.status === 'Rejected' && (
                  <DivLayout
                    heading={localization.remarks}
                    status
                    data={
                      details.lead_data?.reject_remarks
                        ? details.lead_data.reject_remarks
                        : localization.na
                    }
                  />
                )}

                <DivLayout
                  heading={localization.contactDate}
                  status
                  data={
                    details.lead_data?.contact_date
                      ? moment(
                          details.lead_data.contact_date,
                          'DD-MM-YYYY'
                        ).format('DD-MM-YYYY')
                      : localization.na
                  }
                />
                <DivLayout
                  heading={'External User Name'}
                  status
                  data={details?.external_user_name ? details?.external_user_name : localization.na}
                />
                <DivLayout
                  heading={'External User Email'}
                  status
                  data={details?.external_user_email ? details?.external_user_email : localization.na}
                />
                <DivLayout
                  heading={'External User Mobile Number'}
                  status
                  data={details?.external_user_mobile_number ? details?.external_user_mobile_number : localization.na}
                />
                {details?.lead_data?.vendor_allocation && (
                  <DivLayout
                    heading={localization.vendorAllocation}
                    data={details.lead_data.vendor_allocation}
                  />
                )}
                {details?.lead_data?.allocation_reason && (
                  <DivLayout
                    heading={"Allocation Reason"}
                    data={details.lead_data.allocation_reason}
                  />
                )}

              </div>
            </div>
          </div>
          {/* </div> */}
          {details?.lead_data?.poc_type && (
            <>
              <div className="panel-card">
                <div className="panel-heading">{localization.pocTitle}</div>
                <div className="panel-body">
                  <div className="details-listing">
                    {(leadType === STATUS.CORPORATE || teamId === STATUS.CORPORATE ||
                    leadType === STATUS.APARTMENT || teamId === STATUS.APARTMENT) ? (
                      <Fragment>
                        <DivLayout
                          heading={localization.pocType}
                          data={
                            details.lead_data && details.lead_data?.poc_type
                              ? details.lead_data.poc_type
                              : localization.na
                          }
                        />
                        {details.lead_data?.poc_type === 'Other' && (
                          <DivLayout
                            heading={'Other ' + localization.pocType}
                            data={
                              details.lead_data &&
                              details.lead_data?.other_poc_sites
                                ? details.lead_data.other_poc_sites
                                : localization.na
                            }
                          />
                        )}
                      </Fragment>
                    ) : null}
                    {details.lead_data?.tp_poc_details && details.lead_data.tp_poc_details?.fmc_name &&
                    <DivLayout
                      heading={localization.fmcName}
                      data={
                        details.lead_data?.tp_poc_details &&
                        details.lead_data.tp_poc_details?.fmc_name
                          ? details.lead_data.tp_poc_details.fmc_name
                          : localization.na
                      }
                    />
                    }
                    <DivLayout
                      heading={localization.POCName}
                      data={
                        details.lead_data?.tp_poc_details &&
                        details.lead_data.tp_poc_details?.name
                          ? details.lead_data.tp_poc_details.name
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.designation}
                      data={
                        details.lead_data.tp_poc_details &&
                        details.lead_data.tp_poc_details?.designation
                          ? details.lead_data.tp_poc_details.designation
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.phoneNumber}
                      data={
                        details.lead_data.tp_poc_details &&
                        details.lead_data.tp_poc_details?.phone
                          ? details.lead_data.tp_poc_details.phone
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.emailAddress}
                      data={
                        details.lead_data.tp_poc_details &&
                        details.lead_data.tp_poc_details?.email
                          ? details.lead_data.tp_poc_details.email
                          : localization.na
                      }
                    />

                    <DivLayout
                      heading={localization.secondContact}
                      data={
                        details.lead_data.tp_poc_details &&
                        details.lead_data.tp_poc_details?.contact_no
                          ? details.lead_data.tp_poc_details.contact_no
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.mailCamp}
                      data={
                        details.lead_data.tp_poc_details &&
                        details.lead_data.tp_poc_details?.mail_campaign
                          ? details.lead_data.tp_poc_details.mail_campaign
                          : localization.na
                      }
                    />

                    {/* {teamId === STATUS.CORPORATE || teamId === STATUS.APARTMENT ? (
                  <DivLayout
                    heading={localization.secondaryContact}
                    data={
                      details?.lead_data.tp_poc_details?.secondary_contact
                        ? details.lead_data.tp_poc_details.secondary_contact
                        : localization.na
                    }
                  />
                ) : null} */}
                  </div>
                </div>
              </div>
              <div className="panel-card">
                <div className="panel-heading">
                  {localization.locationDetail}
                </div>
                <div className="panel-body">
                  <div className="details-listing ">
                    <DivLayout
                      heading={localization.city}
                      data={
                        details.lead_data?.city
                          ? details.lead_data.city
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.zone}
                      data={
                        details.lead_data?.zone
                          ? details.lead_data.zone
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.area}
                      data={
                        details.lead_data?.area
                          ? details.lead_data.area
                          : localization.na
                      }
                    />
                    <div className="details-list">
                      <strong className="data-title">
                        {localization.address}
                      </strong>
                      <span className="data-details">
                        {details.lead_data?.address_line_one
                          ? details.lead_data.address_line_one
                          : localization.na}{' '}
                        {details.lead_data?.address_line_two}
                      </span>
                    </div>
                    <DivLayout
                      heading={localization.current_location}
                      data={
                        details.lead_data?.current_location
                          ? details.lead_data.current_location
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.lat}
                      data={
                        details.lead_data?.latitude
                          ? details.lead_data.latitude
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.lng}
                      data={
                        details.lead_data?.longitude
                          ? details.lead_data.longitude
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.locationType}
                      data={
                        details.lead_data?.location_type
                          ? details.lead_data.location_type
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.pinCode}
                      data={
                        details.lead_data?.geo_pincode
                          ? details.lead_data.geo_pincode
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.geoState}
                      data={
                        details.lead_data?.geo_state
                          ? details.lead_data.geo_state
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.geoCity}
                      data={
                        details.lead_data?.geo_city
                          ? details.lead_data.geo_city
                          : localization.na
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="panel-card">
                <div className="panel-heading">
                  {localization.categoryDetails}
                </div>
                <div className="panel-body">
                  {(leadType === STATUS.APARTMENT || teamId === STATUS.APARTMENT) && (
                    <Fragment>
                      <div className="details-listing">
                        <DivLayout
                          heading={localization.LeadCategory}
                          data={
                            details.lead_data?.lead_category
                              ? details.lead_data.lead_category
                              : localization.na
                          }
                        />
                       

                        <DivLayout
                          heading={localization.societyType}
                          data={
                            details.lead_data?.society_type
                              ? details.lead_data.society_type
                              : localization.na
                          }
                        />

                        <DivLayout
                          heading={localization.vms}
                          data={
                            details.lead_data?.vms_type
                              ? details.lead_data.vms_type
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.noOfFlats}
                          data={
                            details.lead_data?.no_of_flats
                              ? details.lead_data.no_of_flats
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.existingsetup}
                          data={
                            details.lead_data?.existing_setup
                              ? details.lead_data.existing_setup
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.occupancy}
                          data={
                            details.lead_data?.occupancy
                            ?details.lead_data.occupancy
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.securityAgency}
                          data={
                            details.lead_data?.security_agency
                              ? details.lead_data.security_agency
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.AverageMaintenance}
                          data={
                            details.lead_data?.maintainance_charges
                            ?details.lead_data.maintainance_charges
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.disputeLevel}
                          data={
                            details.lead_data?.dispute_level
                            ?details.lead_data.dispute_level
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.societyUpkeeping}
                          data={
                            details.lead_data?.society_upkeeping
                            ?details.lead_data.society_upkeeping
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.amenities}
                          data={
                            details.lead_data?.amenities
                            ?details.lead_data.amenities
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.managedBy}
                          data={
                            details.lead_data?.managed_by
                            ?details.lead_data.managed_by
                              : localization.na
                          }
                        />
                      </div>
                    </Fragment>
                  )}

                  {(leadType === STATUS.CORPORATE || teamId === STATUS.CORPORATE) && (
                    <Fragment>
                      <div className="details-listing">
                        <DivLayout
                          heading={localization.LeadCategory}
                          data={
                            details.lead_data?.lead_category
                              ? details.lead_data.lead_category
                              : localization.na
                          }
                        />
                        {details.lead_data?.lead_category &&
                          details.lead_data?.lead_category_id === 2 && (
                            <DivLayout
                              heading={localization.supplyNamePost}
                              data={
                                details.lead_data?.supply_name
                                  ? details.lead_data.supply_name
                                  : localization.na
                              }
                            />
                          )}
                        {(details.lead_data?.lead_category_id &&
                          details.lead_data?.lead_category_id === 1) ||
                        (details.lead_data?.lead_category_id &&
                          details.lead_data?.lead_category_id === 3) ? (
                          <>  
                          {details.lead_data?.no_of_gates ? ( 
                          <DivLayout
                            heading={localization.noOfgates}
                            data={
                              details.lead_data?.no_of_gates
                                ? details.lead_data.no_of_gates
                                : localization.na
                            }
                          />
                          ) : null
                          }
                          </>
                        ) : null}

                        {(details.lead_data?.lead_category_id &&
                          details.lead_data?.lead_category_id === 2) ||
                        (details.lead_data?.lead_category_id &&
                          details.lead_data?.lead_category_id === 3) ? (
                          <DivLayout
                            heading={localization.noOfSlots}
                            data={
                              details.lead_data?.no_of_slots
                                ? details.lead_data.no_of_slots
                                : localization.na
                            }
                          />
                        ) : null}
                        {details.lead_data?.lead_category_id &&
                          details.lead_data?.lead_category_id === 2 && (
                            <>
                              <DivLayout
                                heading={localization.reservedSlots}
                                data={
                                  details.lead_data?.reserved
                                    ? details.lead_data.reserved
                                    : localization.na
                                }
                              />
                              <DivLayout
                                heading={localization.FCFSSlots}
                                data={
                                  details.lead_data?.fcfs
                                    ? details.lead_data.fcfs
                                    : localization.na
                                }
                              />
                            </>
                          )}
                        {details.lead_data?.lead_category_id &&
                          details.lead_data?.lead_category_id === 8 && (
                            <>
                              <DivLayout
                                heading={localization.strategicPartner}
                                data={
                                  details.lead_data?.partner
                                    ? details.lead_data.partner
                                    : localization.na
                                }
                              />
                            </>
                          )}
                          <DivLayout
                            heading={localization.noOfSlots}
                            data={
                              details.lead_data?.no_of_slots
                                ? details.lead_data.no_of_slots
                                : localization.na
                            }
                          />
                          {details.lead_data?.no_of_ev_chargers ? (
                          <DivLayout
                            heading={localization.noOfEVChargers}
                            data={
                              details.lead_data?.no_of_ev_chargers
                                ? details.lead_data.no_of_ev_chargers
                                : localization.na
                            }
                          />
                          ) : null }
                          <DivLayout
                            heading={localization.vms}
                            data={
                              details.lead_data?.vms_type
                                ? details.lead_data.vms_type
                                : localization.na
                            }
                          />
                      </div>
                      
                    </Fragment>
                  )}

                  {(leadType === STATUS.SUPPLY || teamId === STATUS.SUPPLY) && (
                    <Fragment>
                      <div className="details-listing">
                        <DivLayout
                          heading={localization.LeadCategory}
                          data={
                            details.lead_data?.lead_category
                              ? details.lead_data.lead_category
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.reqDes}
                          data={
                            details.lead_data?.requirements_description
                              ? details.lead_data.requirements_description
                              : localization.na
                          }
                        />
                      </div>
                    </Fragment>
                  )}

                  {(leadType === STATUS.B2BALLIANCE || teamId === STATUS.B2BALLIANCE) && (
                    <Fragment>
                      <div className="details-listing">
                        <DivLayout
                          heading={localization.remarks}
                          data={
                            details.lead_data?.remarks
                              ? details.lead_data.remarks
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.categoryAlliances}
                          data={
                            details.lead_data?.lead_category
                              ? details.lead_data.lead_category
                              : localization.na
                          }
                        />
                      </div>
                    </Fragment>
                  )}

                 
                </div>
              </div>
              {details.lead_data?.gate_details && (
                     <div className="panel-card">
                     <div className="panel-heading">
                       {localization.gateType}
                     </div>
                     <div className="panel-body">
                      
                       <div className="details-listing">
                       {details.lead_data?.gate_details && details.lead_data?.gate_details.map((item, index) => {
                        return (
                          <div className="row">
                            <div className="col-6">
                              <DivLayout
                                heading={localization.gateType+' '+(Number(index)+1)}
                                data={
                                  item?.gate_type
                                    ? item.gate_type
                                    : localization.na
                                }
                              />
                              </div>
                              <div className="col-6">
                              <DivLayout
                                heading={localization.quantity}
                                data={
                                  item?.gatequantity
                                    ? item.gatequantity
                                    : localization.na
                                }
                              />
                          </div>
                         </div>
                        );
                       })}
                         
                        
                       </div>
                       </div>
                       </div>

                  )}
            </>
          )}

          {details?.lead_data?.ucd_details && (
              <>
                <div className="panel-card">
                  <div className="panel-heading">
                    Dealer Details
                  </div>
                  <div className="panel-body">

                    <div className="details-listing">
                      {details?.lead_data?.ucd_details &&
                          <>
                            <div className="row">
                              <div className="col-6">
                                <DivLayout
                                    heading={"Business Name"}
                                    data={
                                      details?.lead_data?.ucd_details?.business_name
                                          ? details?.lead_data?.ucd_details?.business_name
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Owner Name"}
                                    data={
                                      details?.lead_data?.ucd_details?.owner_name
                                          ? details?.lead_data?.ucd_details?.owner_name
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Firm Type"}
                                    data={
                                      details?.lead_data?.ucd_details?.firm_type
                                          ? details?.lead_data?.ucd_details?.firm_type
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Channel Type"}
                                    data={
                                      details?.lead_data?.ucd_details?.channel_type
                                          ? details?.lead_data?.ucd_details?.channel_type
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Organization Type"}
                                    data={
                                      details?.lead_data?.ucd_details?.organization_type
                                          ? details?.lead_data?.ucd_details?.organization_type
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"GST No."}
                                    data={
                                      details?.lead_data?.ucd_details?.dealer_gst_no
                                          ? details?.lead_data?.ucd_details?.dealer_gst_no
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"PAN No."}
                                    data={
                                      details?.lead_data?.ucd_details?.dealer_pan_no
                                          ? details?.lead_data?.ucd_details?.dealer_pan_no
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Eamil"}
                                    data={
                                      details?.lead_data?.ucd_details?.registration_email
                                          ? details?.lead_data?.ucd_details?.registration_email
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Registration Phone No."}
                                    data={
                                      details?.lead_data?.ucd_details?.registration_mobile_no
                                          ? details?.lead_data?.ucd_details?.registration_mobile_no
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Aadhar No."}
                                    data={
                                      details?.lead_data?.ucd_details?.aadhar_no
                                          ? details?.lead_data?.ucd_details?.aadhar_no
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"MSME Certificate"}
                                    data={
                                      details?.lead_data?.ucd_details?.msme_certificate
                                          ? details?.lead_data?.ucd_details?.msme_certificate
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"MSME No"}
                                    data={
                                      details?.lead_data?.ucd_details?.msme_no
                                          ? details?.lead_data?.ucd_details?.msme_no
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Bank Name"}
                                    data={
                                      details?.lead_data?.ucd_details?.bank_name
                                          ? details?.lead_data?.ucd_details?.bank_name
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Account No."}
                                    data={
                                      details?.lead_data?.ucd_details?.account_no
                                          ? details?.lead_data?.ucd_details?.account_no
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"IFSC Code"}
                                    data={
                                      details?.lead_data?.ucd_details?.ifsc_code
                                          ? details?.lead_data?.ucd_details?.ifsc_code
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Account Type"}
                                    data={
                                      details?.lead_data?.ucd_details?.account_type
                                          ? details?.lead_data?.ucd_details?.account_type
                                          : localization.na
                                    }
                                />
                              </div>
                              <div className="col-6">
                                <DivLayout
                                    heading={"Branch Name"}
                                    data={
                                      details?.lead_data?.ucd_details?.branch_name
                                          ? details?.lead_data?.ucd_details?.branch_name
                                          : localization.na
                                    }
                                />
                              </div>
                              {details?.lead_data?.ucd_details?.upload_cancelled_cheque &&
                                  <div className="col-6">
                                    <DocumentView
                                        attachment={details?.lead_data?.ucd_details?.upload_cancelled_cheque}
                                        title={"Cancelled Cheque"}
                                    />
                                  </div>
                              }



                              {details?.lead_data?.ucd_details?.gst_certificate_photo &&
                                  <div className="col-6">
                                    <DocumentView
                                        attachment={details?.lead_data?.ucd_details?.gst_certificate_photo}
                                        title={"GST Certificate"}
                                    />
                                  </div>
                              }
                              {details?.lead_data?.ucd_details?.pan_card_photo &&
                                  <div className="col-6">
                                    <DocumentView
                                        attachment={details?.lead_data?.ucd_details?.pan_card_photo}
                                        title={"Pan Card"}
                                    />
                                  </div>
                              }
                              {details?.lead_data?.ucd_details?.msme_declaration_photo &&
                                  <div className="col-6">
                                    <DocumentView
                                        attachment={details?.lead_data?.ucd_details?.msme_declaration_photo}
                                        title={"MSME Declaration"}
                                    />
                                  </div>
                              }

                              {details?.lead_data?.ucd_details?.msme_certificate_photo &&
                                  <div className="col-6">
                                    <DocumentView
                                        attachment={details?.lead_data?.ucd_details?.msme_certificate_photo}
                                        title={"MSME Certificate"}
                                    />
                                  </div>
                              }

                              {details?.lead_data?.ucd_details?.selfie_with_dsa &&
                                  <div className="col-6">
                                    <DocumentView
                                        attachment={details?.lead_data?.ucd_details?.selfie_with_dsa}
                                        title={"Selfie With DSA"}
                                    />
                                  </div>
                              }

                            </div>
                          </>
                      }


                    </div>
                  </div>
                </div>
                <div className="panel-card">
                  <div className="panel-heading">
                    Dealer Images
                  </div>
                  <div className="panel-body">

                    <div className="details-listing">
                      <div className="row">
                        {details?.lead_data?.ucd_details?.dealer_images && details?.lead_data?.ucd_details?.dealer_images.map((val, i) => {
                          return (
                              <div className="col-6">
                                <DocumentView
                                    attachment={val}
                                    title={""}
                                />
                              </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </>

          )}
          {details?.lead_data?.client_status_log && (
            <div className="panel-card">
              <div className="panel-heading">BA - Client Alignment Details</div>
              <div className="panel-body">
                <div className="details-listing">
                    <div
                      className="p-3 mb-3 rounded bg-white"
                      style={{ border: "1px solid #ddd", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}
                    >
                      <div className="row">
                        <div className="col-6">
                          <DivLayout
                            heading="Client Alignment"
                            data={details.lead_data.client_status_log?.client_status || localization.na}
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading="Alignment Reason"
                            data={details.lead_data.client_status_log?.client_status_reason || localization.na}
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading="Client Alignment Remarks"
                            data={details.lead_data.client_status_log?.client_status_reason_remarks || localization.na}
                          />
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          )}



        </Fragment>
      )}
    </Fragment>
  );
};

export default LeadDetail;
